/**
 * URL base da API REST.
 * Padrão `/api/v1` (mesmo host): funciona em produção (nginx) e em dev (proxy Vite → backend).
 * Override opcional: `VITE_API_URL` absoluto em `.env.local`.
 */
export function getApiBaseUrl(): string {
  const fromEnv = (import.meta.env.VITE_API_URL as string | undefined)?.trim()
  if (fromEnv) {
    if (/^https?:\/\//i.test(fromEnv)) return fromEnv.replace(/\/?$/, '')
    const path = fromEnv.startsWith('/') ? fromEnv : `/${fromEnv}`
    return path.replace(/\/?$/, '')
  }
  return '/api/v1'
}
